export default {
    _btn: null,
    _close: null,
    _popup: null,
    

    init() {
        this._btn = document.querySelector('[data-product-term]');
        this._close = document.querySelector('[data-product-term-close]');
        this._popup = document.querySelector('[data-product-term-popup]');
        if (!this._btn) {
            return;
        }

        this._btn.addEventListener('click', (e) => {
            e.preventDefault();
            this._popup.classList.add(this._popup.classList[0] +'--active');
        })
        this._close.addEventListener('click', (e) => {
            this._popup.classList.remove(this._popup.classList[0] +'--active');
        })
    }

}